import * as React from 'react';
import { Link } from 'gatsby';
import Button from '../Button';
import './style.scss';
import { useState } from 'react';

const Header = () => {
  const [mobNavActive, setMobNavActive] = useState(false);

  return (
    <header className="header">
      <div className="container">
        <Link to="/" className="logo">
          {/*
            Not using StaticImage here for now due to the below issue:
            https://github.com/gatsbyjs/gatsby/issues/32037
            https://trello.com/c/EHzLCTLD/27-top-navigation-logo-flashes
          */}
          <img src="/annual-report-2020-2021/logo@2x.png" alt="Logo" height={54} width={188} />
        </Link>

        <button
          className={`hamburger hamburger--spin ${mobNavActive ? 'is-active' : ''}`}
          type="button"
          aria-label="Menu"
          aria-controls="navigation"
          onClick={() => setMobNavActive(!mobNavActive)}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner" />
          </span>
        </button>

        <nav className={mobNavActive ? 'mob-nav-active' : ''}>
          <ul>
            <li>
              <Link to="/" activeClassName="is-active">
                2020/21 Snapshot
              </Link>
            </li>
            <li>
              <Link to="/about/" activeClassName="is-active">
                About
              </Link>
            </li>
            <li>
              <Link to="/chair-and-ceo-reports/" activeClassName="is-active">
                Chair and CEO Reports
              </Link>
            </li>
            <li>
              <Link to="/councils-work-and-activities/" activeClassName="is-active">
                Councils' Work and Activities
              </Link>
            </li>
            <li>
              <Button color="primary" to="/reports/" label="View all reports" />
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
